import { getRoutes } from '@ui-framework/index';
import ServiceProviderEdit from './pages/edit/index';
import ServiceProviderCreate from './pages/create/index';
import ServiceProviderList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import {
  ServiceProviderCreateFormStore,
  ServiceProviderEditFormStore,
  ServiceProviderListStore,
  ServiceProviderSearchFormStore,
} from './store';

const Pages = ProtectedRoute => ({
  ServiceProviderEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceProviderEdit}
    />
  ),
  ServiceProviderCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceProviderCreate}
    />
  ),
  ServiceProviderList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceProviderList}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    serviceproviderCreateFormStore: new ServiceProviderCreateFormStore(
      rootStore,
    ),
  },
  { serviceproviderEditFormStore: new ServiceProviderEditFormStore(rootStore) },
  { serviceproviderListStore: new ServiceProviderListStore(rootStore) },
  {
    serviceproviderSearchFormStore: new ServiceProviderSearchFormStore(
      rootStore,
    ),
  },
];

export {
  ServiceProviderEdit,
  ServiceProviderCreate,
  ServiceProviderList,
  routes,
  stores,
};
